import { render, staticRenderFns } from "./DoctorSideBarPayment.vue?vue&type=template&id=8b5af01e&scoped=true"
import script from "./DoctorSideBarPayment.vue?vue&type=script&lang=js"
export * from "./DoctorSideBarPayment.vue?vue&type=script&lang=js"
import style0 from "./DoctorSideBarPayment.vue?vue&type=style&index=0&id=8b5af01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5af01e",
  null
  
)

export default component.exports